import { CircularProgress } from "@mui/material";
import React from "react";

export default function GlobalLoader() {
  return (
    <div
      id="divLoader"
      style={{
        display: "none",
        justifyContent: "center",
        alignItems: "center",
        height: `100vh`,
        width: "100vw",
        position: "fixed",
        zIndex: 50000,
        top: 0,
        left: 0,
        background: "rgba(0,0,0,0.2)",
      }}
    >
      <CircularProgress />
    </div>
  );
}
